import React from "react";
import Variable from "./Variable";

export default function Axis({id, title, variables}) {
	return (
		<section className='axis'>
			<h2 className='axis-title'>{title.toUpperCase()}</h2>
			<ul className='axis-variables'>
				{variables.map((v) => (
					<Variable axisID={id} id={v.id} content={v.content} description={v.description} options={v.hasOwnProperty("options") ? v.options : []} />
				))}
			</ul>
		</section>
	);
}
